<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-lock"></i></div>
      <div>
        Clôture d'année académique
        <div class="page-title-subheading">Clôture et archivage de l'année scolaire</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
<div class="container py-3">
    <form #insForm="ngForm">

    <div class="card" *ngIf="data!=null">
        <div class="card-header">
            <h2>Clôture d'année académique</h2>
        </div>
        <div class="card-body">
            <div #reqTop>
                <igx-stepper #stepper  [linear]="false" [orientation]="'horizontal'" (activeStepChanging)="handleActiveStepChanging($event)" >
                    <igx-step>                    
                        <div igxStepContent>
                            <h4 class="text-center fw-bold mb-3">Bon à savoir </h4>
                            <p>Vous êtes sur le point de clôturer l'année académique. Cette opération prendra en compte les étapes suivantes:</p>
                                <ul>
                                    <li><strong>Migration des apprenants :</strong>
                                        
                                        <ul>
                                            <li><strong>a. Classes évaluées sur notes :</strong> <br>
                                                Les apprenants qui ont atteint la moyenne de passage passent en classe supérieure et la configuration de classe de réprise pour la nouvelle année académique pour les apprenants n'ayant pas obtenus la moyenne de passage.
                                            </li>
                                            <li><strong>b. Classes évaluées sur acquisition du savoir :</strong>
                                                <br>Les apprenants qui ont reçu le droit de passage passent en classe supérieure et la configuration de classe de réprise pour la nouvelle année académique pour les apprenants n'ayant pas obtenus le droit passage.
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        <strong>Transfert des enseignants :</strong> <br>
                                        La programmation des classes et matières pour les enseignants de l'année académique courante est reportée pour la nouvelle année académique.
                                    </li>
                                    <li>
                                        <strong>Transfert des emplois du temps :</strong> <br>
                                        La programmation des emplois du temps pour les enseignants de l'année académique courante est reportée pour la nouvelle année académique.
                                    </li>
                                    <li>
                                        <strong>Processus :</strong> <br>
                                        Les classes sont cloturées par cycle.
                                    </li>
                                </ul>

                         
                         <div class="d-flex justify-content-center mt-5">
                            <button igxButton="raised"  type="button" class="btn btn-primary px-5 rounded-0" (click)="next()">Suivant <i class="fa fa-long-arrow-right"></i></button>
                         </div>
                        </div>
                     </igx-step>
                    <igx-step>                    
                        <div igxStepContent>
                            <h4 class="text-center fw-bold mb-3">Pré-requis </h4>
                            <p>Pour le succès de cette opération, veuilez vous assurer des points suivants:</p>
                                <ol>
                                    <i>Les moyennes générales annuels sont calculées pour toutes les classes de tous les cycles</i>
                                    <i>Les classes de migration ont été configurées avec les moyennes de passage pour les cyles à système de notation</i>
                                    <i>L'année académique courant est désactivée créée</i>
                                    <i>Une nouvelle année académique est créée</i>
                                </ol>

                         
                         <div class="d-flex justify-content-center mt-5">
                            <button igxButton="raised"  type="button" class="btn btn-warning px-5 rounded-0" (click)="prev()">Précédent <i class="fa fa-long-arrow-left"></i></button>
                            <button igxButton="raised"  type="button" class="btn btn-primary px-5 rounded-0" (click)="next()">Suivant <i class="fa fa-long-arrow-right"></i></button>
                         </div>
                        </div>
                     </igx-step>
                     <igx-step>                    
                        <div igxStepContent>
                            <h4 class="text-center fw-bold mb-3">Processus de migration </h4>

                            <ul>
                                <li> 
                                    <span>Migration des apprenants du cycle primaire I</span>
                                    <i *ngIf="data?.primaire1_migrated" class="fa fa-check text-success"></i>
                                    <app-loading  [isVisible]="loading1"></app-loading>
                                </li>
                                <li> 
                                    <span>Migration des apprenants du cycle primaire II</span>
                                    <i *ngIf="data?.primaire2_migrated" class="fa fa-check text-success"></i>
                                    <app-loading  [isVisible]="loading2"></app-loading>
                                </li>
                                <li> 
                                    <span>Migration des apprenants du cycle primaire III</span>
                                    <i *ngIf="data?.primaire3_migrated" class="fa fa-check text-success"></i>
                                    <app-loading  [isVisible]="loading3"></app-loading>
                                </li>
                                <li> 
                                    <span>Migration des apprenants du cycle Collège</span>
                                    <i *ngIf="data?.college_migrated" class="fa fa-check text-success"></i>
                                    <app-loading  [isVisible]="loading4"></app-loading>
                                </li>
                                <li> 
                                    <span>Migration des apprenants du cycle Lycée</span>
                                    <i *ngIf="data?.lycee_migrated" class="fa fa-check text-success"></i>
                                    <app-loading  [isVisible]="loading5"></app-loading>
                                </li>
                                <li> 
                                    <span>Migration des configurations des enseigants</span>
                                    <i *ngIf="data?.professor_migrated" class="fa fa-check text-success"></i>
                                    <app-loading  [isVisible]="loading6"></app-loading>
                                </li>
                                <li> 
                                    <span>Migration des programmes des enseignants</span>
                                    <i *ngIf="data?.program_migrated" class="fa fa-check text-success"></i>
                                    <app-loading  [isVisible]="loading7"></app-loading>
                                </li>
                            </ul>

                            <h1 class="text-success mb-3 text-center">ANNEE ACADEMIQUE CLÔTUREE AVEC SUCCES</h1>
                         <div class="d-flex justify-content-center mt-5">
                            <button igxButton="raised"  type="button" class="btn btn-warning px-5 rounded-0" (click)="prev()">Précédent <i class="fa fa-long-arrow-left"></i></button>
                            <button *ngIf="!data?.is_closed" igxButton="raised"  type="button" class="btn btn-primary px-5 rounded-0" (click)="store()">Commencer <app-loading  [isVisible]="loading8"></app-loading></button>
                         </div>
                        </div>
                     </igx-step>
                </igx-stepper>
            </div>
            
        </div>
    </div>
    </form>
</div>

